<template>
  <div class="flex_container">
    <div
      class="file_item br6 mb24"
      v-for="(item, k) in list"
      :key="k + 'file'"
      v-if="viewType == 'default'"
    >
      <cl-svg-icon
        class="mr4"
        width="40"
        height="54"
        :currentColor="false"
        :icon-class="`tu_file_${$utils.formatSuffix(item.name)}`"
      ></cl-svg-icon>
      <div style="width: calc(100% - 60px)">
        <el-tooltip
          class="item"
          effect="dark"
          :content="item.name"
          placement="top"
        >
          <p
            class="Black2_Color fs14 SysFontM mt8 Text_Over"
            style="line-height: 20px; max-width: 100% !important"
          >
            {{ item.name }}
          </p>
        </el-tooltip>
        <p class="Tip_Color fs12 AkrobatR">{{ item.size }}</p>
      </div>
      <div v-if="showIcon" class="operate_btns">
        <cl-svg-icon
          v-show="canView(item)"
          @click.native="view(item)"
          width="36"
          height="36"
          :currentColor="false"
          icon-class="tu_file_view"
        ></cl-svg-icon>
        <cl-svg-icon
          v-show="hasDownload"
          @click.native="download(item)"
          class="ml14 mr14"
          width="36"
          height="36"
          icon-class="tu_file_download"
        ></cl-svg-icon>
        <cl-svg-icon
          @click.native="deleteFile(item)"
          v-if="!disabled"
          width="36"
          height="36"
          :currentColor="false"
          icon-class="tu_file_delete"
          class="del_icon"
        ></cl-svg-icon>
      </div>
    </div>
    <div
      class="file_item br6 mb24 slot_file_item"
      v-if="viewType == 'default' && showSlot"
    >
      <slot name="suffixAction"></slot>
    </div>
    <div
      class="file_item br6 mb24 view_type"
      v-for="(item, k) in list"
      :key="k + 'file'"
      v-if="viewType == 'view'"
    >
      <cl-svg-icon
        @click.native="deleteFile(item)"
        class="del_img"
        width="14"
        height="14"
        icon-class="del_upload_img"
      />
      <img
        class="show_img"
        @click="view(item)"
        v-if="
          $utils.formatSuffix(item.name) == 'mov' ||
          $utils.formatSuffix(item.name) == 'mp4'
        "
        :src="item.snapshot"
        alt=""
      />
      <img class="show_img" @click="view(item)" v-else :src="item.url" alt="" />
      <cl-svg-icon
        class="video_play"
        @click.native="view(item)"
        v-if="
          $utils.formatSuffix(item.name) == 'mov' ||
          $utils.formatSuffix(item.name) == 'mp4'
        "
        width="44"
        height="44"
        :currentColor="false"
        icon-class="tu_file_view"
      ></cl-svg-icon>
    </div>
    <div class="btn_wrapper">
      <cl-annex v-if="!disabled && showAnnex" @click="handleAnnex"></cl-annex>
    </div>
    <!-- 预览 -->
    <el-dialog
      :visible.sync="previewDialog"
      width="760px"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <div slot="title" style="position: relative">
        <p class="Text_Left pl24 fs14 Major_Color SysFontM">
          {{ previewItem.name }}
        </p>
        <p class="Text_Left pl24 fs14 AkrobatR mt5" style="color: #81818a">
          {{ $moment(previewItem.createTime).format("YYYY/MM/DD HH:mm:ss") }}
          <span class="ml15 AkrobatR" style="color: #81818a">{{
            previewItem.size
          }}</span>
        </p>
        <cl-svg-icon
          v-show="hasDownload"
          @click.native="download(previewItem)"
          class="view_down_btn"
          width="36"
          height="36"
          icon-class="tu_file_download"
          color="#B7B7BF"
        ></cl-svg-icon>
      </div>
      <div class="preview">
        <img v-if="imageURL" :src="imageURL" />
        <video
          v-if="videoURL"
          controls
          width="698"
          :src="videoURL"
          controlslist="nodownload"
          disablePictureInPicture
        ></video>
      </div>
    </el-dialog>
    <!-- 添加附件 -->
    <el-dialog
      :title="title ? title : $t('schedule.添加附件')"
      :visible.sync="annexDialog"
      width="760px"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <cl-file-tree
        :accept="accept"
        v-model="annexList"
        class="dialog_file_list"
      ></cl-file-tree>
      <span slot="footer">
        <div
          class="has_selected fs14"
          v-html="$t('schedule.已选文件', { num: annexList.length })"
        ></div>
        <el-button v-waves @click="annexDialog = false">{{
          $t("common.取消")
        }}</el-button>
        <el-button v-waves type="primary" @click="confirm">{{
          $t("common.确定")
        }}</el-button>
      </span>
    </el-dialog>
    <!-- 下载 -->
    <cl-process-bar
      v-if="downLoadDig"
      :fileData="fileData"
      @close="closeDown"
    ></cl-process-bar>
  </div>
</template>

<script>
/**
 * ComponentName: file list
 * Created Date:2022/4/28
 * Author: Nancy
 * 组件说明：
 * 传入文件列表，根据每个文件类型不同显示不同的icon
 * eg:
 *     <cl-file-list v-model="list"></cl-file-list>
 */
const ipcRenderer = window.require
  ? window.require("electron").ipcRenderer
  : "";
export default {
  name: "cl-file-list",
  data() {
    return {
      list: this.value || [],
      imageURL: "", // 图片URL
      videoURL: "", // 视频URL
      previewItem: {}, // 预览项
      previewDialog: false, // 预览弹窗
      annexDialog: false, // 添加附件弹窗

      annexList: [], // 已选择的附件列表
      downLoadDig: false, // 单个下载
      fileData: {
        // 下载文件数据
        name: "",
        size: "",
        progressBar: 0,
      },
    };
  },
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    title: {
      type: String,
    },
    value: {
      type: [String, Array],
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hasDownload: {
      type: Boolean,
      default: true,
    },
    showAnnex: {
      type: Boolean,
      default: true,
    },
    // 需要展示的文件格式
    accept: {
      type: String,
      default: "",
    },
    // 是否是文档库下载 (梯队伤病附件走普通下载)
    documentDownload: {
      type: Boolean,
      default: true,
    },
    // 是否显示操作icon
    showIcon: {
      type: Boolean,
      default: true,
    },
    // 两种视图模式
    viewType: {
      type: String,
      default: "default",
    },
    // 数量限制
    limit: {
      type: Number,
      default: 0,
    },
    // 外部处理删除事件
    handleDeleteBySelf: {
      type: Boolean,
      default: false,
    },
    // 是否在文件列表尾部，添加一个slot
    showSlot: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    value: {
      handler() {
        this.list = JSON.parse(JSON.stringify(this.value));
      },
      deep: true,
    },
  },

  created() {
    if (!this.documentDownload) return;
    ipcRenderer &&
      ipcRenderer.on("oss-download-res", (event, res) => {
        console.log("download");
        let size = this.$utils.reverseUnitTran(res.size);
        let progressBar =
          parseInt((res.downloadLength / size) * 100) > 100
            ? 99
            : parseInt((res.downloadLength / size) * 100);
        this.fileData.progressBar = progressBar;
      });
    ipcRenderer &&
      ipcRenderer.on("oss-download-finished", () => {
        console.log("okkkkk");
        this.$message.success(this.$t("common.下载完成"));
        this.fileData.progressBar = 100;
      });
  },

  methods: {
    // 预览文件
    view(item) {
      let arr = item.name.split(".");
      let ext = arr[arr.length - 1].toLowerCase();
      this.imageURL = "";
      this.videoURL = "";
      if (["jpeg", "png", "jpg"].includes(ext)) {
        this.imageURL = item.url;
      }
      if (["mp4", "mov"].includes(ext)) {
        this.videoURL = item.url;
      }
      this.previewItem = item;
      this.previewDialog = true;
    },
    canView(item) {
      let arr = item.name.split(".");
      let ext = arr[arr.length - 1].toLowerCase();
      return ["jpeg", "png", "jpg", "mp4", "mov"].includes(ext);
    },
    // 普通下载
    normalDownload(item) {
      let params = {
        ids: item.id,
      };
      // 下载前先检查文件是否存在
      this.$server.getDownloadFile(params).then((res) => {
        if (res && res.code === 200) {
          let url = `${this.$baseUrl.REQUEST_URL}${this.$api.download_attachment}?fileId=${item.id}`;
          window.location.href = url;
        } else {
          this.$message.warning(this.$t("message.文件不存在"));
        }
      });
    },
    // 下载文件
    download(item) {
      // console.log(this.fileData.progressBar)
      if (!this.documentDownload) {
        this.normalDownload(item);
        return;
      }
      if (
        !(this.fileData.progressBar == 100 || this.fileData.progressBar == 0)
      ) {
        this.$message.warning(this.$t("message.有文件正在下载，请稍后"));
        return;
      }
      this.downLoadDig = true;
      this.fileData.name = item.name;
      this.fileData.size = item.size;
      this.fileData.progressBar = 0;

      this.$server.getTokenByOss().then((res) => {
        let ossData = {
          region: "oss-cn-beijing",
          accessKeyId: res.data.accessKeyId,
          accessKeySecret: res.data.accessKeySecret,
          bucket: this.$baseUrl.ossBucketFile,
          stsToken: res.data.securityToken,
        };
        ipcRenderer.send("oss-download", {
          fileData: item,
          ossData,
        });
      });
    },
    // 关闭进度条
    closeDown() {
      this.downLoadDig = false;
    },
    // 删除文件
    deleteFile(item) {
      if (this.handleDeleteBySelf) {
        this.$emit("del-file", item);
      } else {
        this.$emit("del-file", item);
        let index = this.list.findIndex((el) => el.id === item.id);
        this.list.splice(index, 1);
        this.annexList = JSON.parse(JSON.stringify(this.list));
        this.$emit("change", this.list);
      }
    },
    // 打开添加附件弹窗
    handleAnnex() {
      this.annexDialog = true;
      this.annexList = JSON.parse(JSON.stringify(this.list));
    },
    // 确定添加
    confirm() {
      this.annexList =
        this.limit && this.annexList.length > this.limit
          ? this.annexList.slice(this.annexList.length - this.limit)
          : this.annexList;
      this.$emit("change", this.annexList);
      this.annexDialog = false;
    },
  },
};
</script>
<style lang='scss' scoped>
/deep/.el-dialog__body {
  padding-top: 0 !important;
}

.preview {
  width: 100%;
  max-height: 568px;
  overflow-y: auto;

  img {
    width: 100%;
    height: 100%;
    margin: 0 auto;
  }
}

.flex_container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  .btn_wrapper {
    width: 100%;
  }
}

.file_item {
  border: 1px solid #ededf4;
  box-sizing: border-box;
  padding: 5px 0 5px 12px;
  width: 170px;
  height: 64px;
  display: inline-flex;
  position: relative;
  margin-right: 24px;
  &.slot_file_item {
    display: flex;
    align-items: center;

    ::v-deep .file_add_btn i {
      font-weight: bold;
    }
  }

  &:hover {
    .operate_btns {
      opacity: 1;
    }
  }

  .operate_btns {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0;

    /deep/.svg-icon {
      min-width: 36px;
      background: rgba(2, 2, 2, 0.8);
      border-radius: 6px;
      color: #fff;

      &:hover {
        background-color: $base-color-theme;

        &.del_icon {
          background-color: $base-font-error;
        }
      }
    }
  }

  &.view_type {
    display: inline-block;
    width: 164px;
    height: 92px;
    border-radius: 4px;
    position: relative;
    padding: 0;
    margin-right: 15px;
    cursor: pointer;
    border: none;

    .del_img {
      position: absolute;
      right: -7px;
      top: -7px;
      display: none;
    }
    .show_img {
      width: 100%;
      height: 100%;
    }
    .video_play {
      position: absolute;
      top: 24px;
      left: 60px;
    }

    &:hover {
      .del_img {
        display: block;
      }
    }
  }
}

/deep/.el-dialog__footer {
  position: relative;
}

.has_selected {
  position: absolute;
  top: 24px;
  left: 40px;
}
.view_down_btn {
  position: absolute;
  /*top: 18px;*/
  top: -6px;
  right: 56px;
  &:hover {
    color: #3663e1;
  }
}
// 修改弹窗添加附件的里面的文档列表的样式
::v-deep .dialog_file_list {
  .el-table__row:not(.current-row):hover {
    .item {
      color: #fff !important;
    }
    .creator {
      color: #fff !important;
    }
    .size {
      color: #fff !important;
    }
  }
  .el-table__header-wrapper {
    tr {
      th:first-child {
        .cell {
          padding-left: 48px;
        }
      }
    }
  }
  .el-table__body-wrapper {
    .item {
      color: #3a3a3a;
      font-family: SysFontM;
    }
    .creator {
      color: #3a3a3a;
    }
    .size {
      color: #81818a;
    }
    .el-checkbox {
      margin-right: 24px;
    }
  }
}
</style>
